let productSlider = null;
let quickShopSlider = null;


/**
* background Overlay
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
    this.searchDrawer = document.querySelector('search-modal');
    this.desktopSearch = document.querySelector(".desktop-searchs");
    this.sortBy = document.querySelector(".sortby-dropdown");
    this.bindEvents();
  }

  connectedCallback() {
    
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    const closeCart = this.cartDrawer && this.cartDrawer.classList.contains("opened-drawer");
    const closeMenu = this.menuDrawer && this.menuDrawer.classList.contains("opened-drawer");
    const closeSearch = this.searchDrawer && this.searchDrawer.classList.contains("open__modal");
    const closeDesktopSearch = this.desktopSearch && this.desktopSearch.classList.contains("open");
    const sortBy = this.sortBy && this.sortBy.classList.contains("sort-active");
    if(closeCart) document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    if(closeMenu) document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    if(closeSearch) this.searchDrawer.querySelector('.close-search').dispatchEvent(new Event('click'));
    if(closeDesktopSearch) document.querySelector(".close-search").dispatchEvent(new Event('click'));
    if(sortBy) document.querySelector("[data-closefilter]").dispatchEvent(new Event('click'));
    document.dispatchEvent(new CustomEvent('overlay:clicked'));
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.body.classList.remove('scroll-fixed');
    document.querySelector('predictive-search')?.closeSearch('overlay');
    document.dispatchEvent(new CustomEvent('site-overlay:hidden'));
  }
}
customElements.define("site-overlay", siteOverlay, {once: true});

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.element = element;
    this.dropdownParent = element.parentElement;
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    this.supportedEvents = ["click"];
    if (!this.isTouchDevice) this.supportedEvents = ["mouseover", "focusin", "click", "mouseout", "touchstart"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click') {
        this.element.addEventListener(type, (evt) => {
          if (evt.currentTarget.classList.contains('nav-link') && evt.target.classList.contains('icon-right-arrow')) {
            evt.preventDefault();
          }
          evt.stopPropagation();
          this.handleDropdownEvent(evt);
        });
      } 
      else if (type === 'mouseout' || type === 'touchstart') {
        this.dropdownParent.addEventListener(type, (evt) => {
          if (evt.currentTarget.classList.contains('nav-link') && evt.target.classList.contains('icon-right-arrow')) {
            evt.preventDefault();
          }
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (!mobileContainer) {
            this.dropdownHide(this.dropdownParent, evt.type);
          }
        }, true);
      } else if (type === 'mouseover' || type === 'focusin') {
        this.dropdownParent.addEventListener(type, (evt) => {
          if (evt.currentTarget.classList.contains('nav-link') && evt.target.classList.contains('icon-right-arrow')) {
            evt.preventDefault();
          }
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (!mobileContainer) {
            this.dropdownShow(this.dropdownParent);
          }
        });
        this.element.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdownParent);
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    let closeBtn = this.dropdownParent.querySelector('.close-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        let parentElement = evt.currentTarget.closest('.dropdown');
        if (parentElement) this.dropdownToggle(parentElement);
      });
    }
    document.addEventListener('overlay:clicked', () => {
      this.dropdownHide(this.dropdownParent);
    });
  }

  handleDropdownEvent(evt) {
    /* let currentTarget = evt.currentTarget;
    let liveTarget = evt.target;
    if (liveTarget.classList.contains('nav-link-title')) {
      let linkHref = currentTarget.getAttribute('data-href');
      if (linkHref) window.location.href = linkHref;
    } else {*/
      this.dropdownToggle(this.dropdownParent);
    /* } */
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }

    this.element.setAttribute('aria-expanded', true);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.add('open');
    } else {
      Utility.toggleElement(dropdownParent, 'open');
    }

    if (dropdownParent.classList.contains('megamenu')) {
      document.body.classList.add('menu-search-open');
      siteOverlay.prototype.showOverlay();
    }
  }

  dropdownHide(dropdownParent, eventType) {
    if (!dropdownParent) {
      return;
    }
   
    this.element.setAttribute('aria-expanded', false);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.remove('open');
    } else {
      Utility.toggleElement(dropdownParent, 'close');
    }

    if (eventType === 'mouseout' && dropdownParent.parentElement.closest('.dropdown')) {
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if (child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
    if (dropdownParent.classList.contains('megamenu')) {
      document.querySelector('#site-overlay').classList.remove('overlay--body');
      document.querySelector('body').classList.remove('scroll-fixed');
    }
  }

  childOnFocusChange(dropdownParent) {
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
class DefaultNavItem {
  constructor(element) {
    this.element = element;
    this.supportedEvents = ["click", "touchstart"];
    
    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      this.element.addEventListener(type, (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
        let currentTarget = e.currentTarget;

        // Toggle dropdown if it was clicked
        if (currentTarget.nextElementSibling) {
          document.querySelectorAll('.megamenu').forEach((ele) =>{
            if (ele.classList.contains('open')) {
              ele.classList.remove('open');
            }
          })
          currentTarget.nextElementSibling.classList.toggle('open');
          currentTarget.nextElementSibling.setAttribute('aria-expanded', currentTarget.nextElementSibling.classList.contains('open'));
        }
      });
    });
}
}

const allDefaultNav = document.querySelectorAll('.desktop-navbar .nav-item a:not(#cart-icon-desktop)');
allDefaultNav.forEach((ele) => {
  new DefaultNavItem(ele);
});

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
    this.sliderOptions = JSON.parse(this.sliderEle.getAttribute('data-slider'));
  }

  static get observedAttributes() {
    return ["data-slider"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-slider" && newValue) {
      this.sliderOptions = JSON.parse(newValue);
    }
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let thumbSlider = null;

    // Set up nav slider 
    if(this.sliderEle.hasAttribute('data-nav')){
      thumbSlider = document.querySelector(`.${this.sliderEle.getAttribute('data-nav')}`);
      if(!thumbSlider){
        return;
      }

      const thumbSliderOptions = JSON.parse(thumbSlider.getAttribute('data-slider'));
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
      
      this.sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    const isCarouselSection = this.sliderEle.classList.contains('carousel-section-swiper');
    this._carouselWheelSwiper = null;

    if (isCarouselSection) {
      const wheelGuard = (e) => {
        const swiper = this._carouselWheelSwiper;
        if (!swiper || !this.carouselSectionCanScroll(swiper)) {
          e.stopImmediatePropagation();
        }
      };
      this.addEventListener('wheel', wheelGuard, { capture: true, passive: true });
      this.sliderEle.addEventListener('wheel', wheelGuard, { capture: true, passive: true });
    }

    const sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);
    this.sliderInstance = sliderInstance;

    if (isCarouselSection) {
      this._carouselWheelSwiper = sliderInstance;
    }

    if(this.sliderEle.classList.contains('product-carousel')){
      productSlider = sliderInstance;
    }else if(this.sliderEle.classList.contains('quickshop-slider')){
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
    this.initImageTextSliderVideoAdvance(sliderInstance);
    this.initCarouselSectionMousewheel(sliderInstance);

    setTimeout(() => {
      sliderInstance.update();
      sliderInstance.navigation.update();
      if (this.sliderEle.classList.contains('carousel-section-swiper')) {
        this.syncCarouselSectionMousewheel(sliderInstance);
      }
    }, 100);
  }

  carouselSectionCanScroll(swiper) {
    return !!(swiper.allowSlideNext || swiper.allowSlidePrev);
  }

  syncCarouselSectionMousewheel(swiper) {
    if (!this.sliderEle?.classList.contains('carousel-section-swiper')) return;

    const canScroll = this.carouselSectionCanScroll(swiper);
    if (swiper.mousewheel) {
      if (canScroll) {
        swiper.params.mousewheel.enabled = true;
        swiper.mousewheel.enable();
      } else {
        swiper.params.mousewheel.enabled = false;
        swiper.mousewheel.disable();
      }
    }
  }

  initCarouselSectionMousewheel(swiper) {
    if (!this.sliderEle?.classList.contains('carousel-section-swiper')) return;

    this.syncCarouselSectionMousewheel(swiper);

    let resizeTimer;
    const onCarouselResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        swiper.update();
        this.syncCarouselSectionMousewheel(swiper);
      }, 150);
    };

    window.addEventListener('resize', onCarouselResize, { passive: true });
    swiper.on('resize', () => this.syncCarouselSectionMousewheel(swiper));
    swiper.on('update', () => this.syncCarouselSectionMousewheel(swiper));
    swiper.on('slideChange', () => this.syncCarouselSectionMousewheel(swiper));
  }

  /**
   * Image with text slider: when a slide has data-advance-on-video-end, stop Swiper autoplay until
   * the local <video> fires "ended", then slideNext and restart autoplay.
   */
  initImageTextSliderVideoAdvance(swiper) {
    if (!this.sliderEle || !this.sliderEle.closest('.image-with-text-slider')) return;
    if (!this.sliderEle.querySelector('[data-advance-on-video-end="true"]')) return;

    const autoplayOn = !!(swiper.params.autoplay && swiper.params.autoplay !== false);

    const cleanupEnded = () => {
      if (this._imageTextAdvanceVideoEndCleanup) {
        this._imageTextAdvanceVideoEndCleanup();
        this._imageTextAdvanceVideoEndCleanup = null;
      }
    };

    const onTransitionEnd = () => {
      cleanupEnded();
      const active = swiper.slides[swiper.activeIndex];
      if (!active) return;
      const advance = active.getAttribute('data-advance-on-video-end') === 'true';
      const video = active.querySelector('.banner-img video');

      if (advance && video) {
        if (autoplayOn && swiper.autoplay) swiper.autoplay.stop();
        const onEnded = () => {
          cleanupEnded();
          swiper.slideNext();
          if (autoplayOn && swiper.autoplay) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                swiper.autoplay.start();
              });
            });
          }
        };
        video.addEventListener('ended', onEnded);
        this._imageTextAdvanceVideoEndCleanup = () => {
          video.removeEventListener('ended', onEnded);
        };
      } else if (autoplayOn && swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    };

    swiper.on('slideChangeTransitionEnd', onTransitionEnd);
    swiper.on('beforeDestroy', cleanupEnded);

    const runInitial = () => requestAnimationFrame(() => onTransitionEnd());
    if (swiper.initialized) {
      runInitial();
    } else {
      const onInit = () => {
        swiper.off('init', onInit);
        runInitial();
      };
      swiper.on('init', onInit);
    }
  }

  slideChangeEvt(slider, thumbSlider){   
    slider.on('slideChange', (event) => {
      if(thumbSlider) thumbSlider.slideTo(slider.activeIndex);

      const activeVideos = slider.el.querySelectorAll(
        ".custom-video-container.playing--video"
      );

      if(activeVideos.length > 0){        
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.el.querySelectorAll('.swiper-slide video').forEach((v) => v.pause());
          slider.el.querySelectorAll('.swiper-slide iframe[src*="youtube.com/embed"]').forEach((iframe) => {
            if (iframe.contentWindow) {
              iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
          });
          const activeSlide = slider.el.querySelector('.swiper-slide-active');
          if (activeSlide) {
            const activeVid = activeSlide.querySelector('video');
            if (activeVid) activeVid.play().catch(() => {});
            const activeYt = activeSlide.querySelector('iframe[src*="youtube.com/embed"]');
            if (activeYt && activeYt.contentWindow) {
              activeYt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
          }
        });
      });

      // 3D modal: load the newly active slide's model-viewer after Swiper has applied .swiper-slide-active
      if (slider.el.closest && slider.el.closest('[data-modal-slider]')) {
        const runForActiveSlide = () => {
          const activeSlide = slider.el.querySelector('.swiper-slide-active');
          const productModel = activeSlide ? activeSlide.querySelector('product-model') : null;
          if (productModel && typeof productModel.loadDeferredContent === 'function') {
            productModel.loadDeferredContent(true);
          }
        };
        requestAnimationFrame(() => {
          requestAnimationFrame(runForActiveSlide);
        });
      }
    });
  }
 }
 let lookForSwiper = setInterval(() => {
  if(typeof Swiper == 'function'){
    customElements.define('slider-element', sliderElement);
    clearInterval(lookForSwiper);
  } 
}, 100);

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container?.querySelector('[data-trigger-video]');
    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event){
    let isOpen = this.container.classList.contains('playing--video');
    if(isOpen){
      this.container.classList.remove('playing--video');
    }else{
      if(this.videoStatus == 'empty' || this.placementType == 'popup'){
        const videoElement = this._buildVideo();
        videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);;
        this.videoSection.appendChild(videoElement);
        this.videoStatus = 'loaded';
      
        setTimeout(() => {
          (this.placementType == 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
          this.pauseOnVisibilityChange(videoElement);
          this._playVideo(videoElement);
        }, 700);        
      }else{
        const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
        this.container.classList.add('playing--video');
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      video.setAttribute('controlslist', 'nodownload');
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    let scrollObserver = new IntersectionObserver((entries) => { 
      if((this.type == 'local' && videoEle == undefined) || (this.type == 'youtube' && videoEle.contentWindow == null)){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            videoEle.pause();
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo || posterVideo == undefined) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();         
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelectorAll('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener) => {
        opener.addEventListener('click', (evt)=>{
          evt.preventDefault();
          if (!opener.hasAttribute('data-shopify-xr-hidden') && opener.hasAttribute('data-shopify-xr')) {
            const model3dId = evt.currentTarget.getAttribute('data-shopify-model3d-id');
            if (window.ProductModel?.ensureXRModelById) {
              window.ProductModel.ensureXRModelById(model3dId);
            }
            window.ShopifyXR.launchXR({
              model3dId: model3dId
            });
          } else {
            this.show(opener);
          }
        });
    });

    if(this.closeBtn){
      this.closeBtn.forEach(button => {
        button.addEventListener('click', this.hide.bind(this));
      });      
    }

    this.addEventListener('click', (evt) => {
      if (!evt.target.closest('.modal-content')) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    // Utility.trapFocus(this);
    
    // Ensure the 3D modal shows the correct slide for the current variant
    if (this.id === 'ProductPopup-space' && window.globalVariables?.product?.currentVariant) {
      // Ensure all loaded product-model elements hide their placeholders
      const productModels = this.modal.querySelectorAll('product-model[loaded="true"]');
      productModels.forEach(model => {
        const placeholder = model.querySelector('[data-img-placeholder]');
        if (placeholder) {
          placeholder.style.display = 'none';
        }
      });
      
      // Remove Shopify's __disabled class so model-viewer rotate/zoom work in modal
      const modelViewers = this.modal.querySelectorAll('model-viewer');
      const enableModelViewers = () => {
        modelViewers.forEach(mv => {
          if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
            mv.classList.remove('shopify-model-viewer-ui__disabled');
          }
          mv.setAttribute('camera-controls', 'true');
        });
      };
      enableModelViewers();
      [0, 50, 100, 200, 400, 700].forEach(ms => setTimeout(enableModelViewers, ms));
      const intervalId = setInterval(enableModelViewers, 100);
      setTimeout(() => clearInterval(intervalId), 2500);
      // Focus the visible model-viewer so it can receive interaction
      setTimeout(() => {
        const visibleSlide = this.modal.querySelector('.swiper-slide-active product-model model-viewer');
        if (visibleSlide) visibleSlide.focus();
      }, 300);

      // Ensure the currently active slide's 3D model loads (in case it was hidden and deferred)
      const activeSlideEl = this.modal.querySelector('.swiper-slide-active');
      const activeProductModel = activeSlideEl ? activeSlideEl.querySelector('product-model') : null;
      if (activeProductModel && typeof activeProductModel.loadDeferredContent === 'function') {
        activeProductModel.loadDeferredContent(true);
      }

      const setModal3DPointerEvents = () => {
        const slides = this.modal.querySelectorAll('[data-modal-slider] .swiper-slide');
        const activeSlide = this.modal.querySelector('[data-modal-slider] .swiper-slide-active');
        slides.forEach((slide) => {
          const pm = slide.querySelector('product-model');
          const mv = slide.querySelector('model-viewer');
          const isActive = slide === activeSlide;
          const pe = isActive ? 'auto' : 'none';
          const z = isActive ? '2' : '0';
          slide.style.setProperty('z-index', z, 'important');
          slide.style.setProperty('pointer-events', isActive ? 'auto' : 'none', 'important');
          if (pm) pm.style.setProperty('pointer-events', pe, 'important');
          if (mv) mv.style.setProperty('pointer-events', pe, 'important');
        });
      };
      setModal3DPointerEvents();
      setTimeout(setModal3DPointerEvents, 100);
      setTimeout(setModal3DPointerEvents, 400);

      // Watch for active slide changes (arrows, swipe, or programmatic) – slideChange may not fire on this slider
      const wrapper = this.modal.querySelector('[data-modal-slider] .swiper-wrapper');
      if (wrapper && !this._modal3DSlideObserver) {
        let lastActiveId = activeSlideEl ? (activeSlideEl.getAttribute('data-modal-id') || activeSlideEl.getAttribute('data-model-slide-index')) : null;
        this._modal3DSlideObserver = new MutationObserver(() => {
          const active = this.modal.querySelector('.swiper-slide-active');
          const activeId = active ? (active.getAttribute('data-modal-id') || active.getAttribute('data-model-slide-index')) : null;
          if (activeId !== lastActiveId) {
            lastActiveId = activeId;
            const pm = active ? active.querySelector('product-model') : null;
            if (pm && typeof pm.loadDeferredContent === 'function') {
              pm.loadDeferredContent(true);
            }
            setModal3DPointerEvents();
            setTimeout(setModal3DPointerEvents, 50);
          }
        });
        this._modal3DSlideObserver.observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      
      // Find the variant-selects component and call applyCurrentModelSlide
      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects && typeof variantSelects.applyCurrentModelSlide === 'function') {
        // Check if Swiper is initialized
        const sliderElement = document.querySelector('[data-modal-slider]');
        const swiperElement = sliderElement?.querySelector('.swiper');
        const swiperInstance = swiperElement?.swiper;
        
        // Use multiple timeouts to ensure Swiper is initialized
        // Try immediately first
        variantSelects.applyCurrentModelSlide(window.globalVariables.product.currentVariant);
        
        // Then try again after a short delay
        setTimeout(() => {
          variantSelects.applyCurrentModelSlide(window.globalVariables.product.currentVariant);
        }, 200);
        
        // Final retry after longer delay
        setTimeout(() => {
          variantSelects.applyCurrentModelSlide(window.globalVariables.product.currentVariant);
        }, 500);
      }

      // If URL has modelID (e.g. from QR scan), show that model's slide so the correct 3D/AR is shown
      const urlModelID = new URLSearchParams(window.location.search).get('modelID');
      if (urlModelID) {
        const slideToModelID = () => {
          const slideByModel = this.modal.querySelector(`[data-modal-slider] .swiper-slide[data-modal-id="${urlModelID}"]`);
          if (slideByModel) {
            const slideIndex = parseInt(slideByModel.getAttribute('data-model-slide-index'), 10);
            if (!isNaN(slideIndex)) {
              const sliderElement = this.modal.querySelector('[data-modal-slider]');
              const swiperInstance = sliderElement?.querySelector('.swiper')?.swiper;
              if (swiperInstance && slideIndex >= 0 && slideIndex < swiperInstance.slides.length) {
                swiperInstance.slideTo(slideIndex, 0, false);
                const pm = slideByModel.querySelector('product-model');
                if (pm && typeof pm.loadDeferredContent === 'function') pm.loadDeferredContent(true);
              }
            }
          }
        };
        setTimeout(slideToModelID, 100);
        setTimeout(slideToModelID, 550);
      }
    }
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);

    if (this.id === 'ProductPopup-space' && this._modal3DSlideObserver) {
      this._modal3DSlideObserver.disconnect();
      this._modal3DSlideObserver = null;
    }
    if(this.id == 'PopupModal-video'){
      this.querySelector('.video-container').innerHTML = '';
    }
    if(this.id == 'rel-add-product'){
      this.successMessageEle = this.querySelector('[data-success-message]');
      this.form = this.querySelector('form');
      this.successMessageEle.classList.add('d-none')
      this.form.classList.remove('d-none');
      this.dispatchEvent(new CustomEvent('rel-modal-hidden', { bubbles: true }));
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  /**
   * Notification Type
   * @param title 
   * @param body 
   * @param options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    cancelAnimationFrame(this.animateNotifcation);
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", Notification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

if (navigator.userAgent.indexOf("iPhone") > -1 && document.querySelector("[name=viewport]").setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1"),
window.globalVariables?.template == "page") {
    let firstdiv = document.querySelector(".template-page-title ~ div")?.getAttribute("id");
    document.querySelector("[scrolldown]") && document.querySelector("[scrolldown]").addEventListener("click", e => {
      e.preventDefault();
      if (firstdiv) document.getElementById(firstdiv).scrollIntoView();
    }
  )
}


// Sticky Header

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Calls when Component is Initialized in DOM
   *
   */
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);
    
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky');
    };

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.setHeightVariables();
  }

  /**
   * Calls when Component is removed from DOM
   *
   */
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  /**
   * To observe Sticky header visibility on User Scroll
   *
   */
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  /**
   * Window Scroll event
   *
   */
  onScroll() {
    if(typeof isScrollToPosition === "undefined") {
      isScrollToPosition = false  
    }
    if (isScrollToPosition) {
      return 
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // console.log(scrollTop, this.currentScrollTop, this.headerBounds.bottom);
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  /**
   * Hide Sticky header
   * Close Menu Drawer / Seach Modal / Cart Drawer
   *
   */
  hide() {
    if (!this.headerIsAlwaysSticky){
      this.header.classList.add('header-hidden', 'header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
    }    
  }

  /**
   * Show Sticky Header
   *
   */
  reveal() {
    if (!this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky', 'animate');
      this.header.classList.remove('header-hidden');

      this.setHeightVariables();
      // fixing the Scroll jump issue on PLP
      setTimeout(() => {
        window.dispatchEvent(new Event('scroll'));
        window.dispatchEvent(new Event('resize'));
      }, 10);
    }
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('header-hidden', 'header-sticky', 'animate');
    // fixing the Scroll jump issue on PLP
    this.setHeightVariables();
    setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    }, 10);
  }

  setHeightVariables() {
    if (document.querySelector(".section-header") != null) {
      let topbarHeight = document.querySelector(".section-header").clientHeight;
      document.documentElement.style.setProperty("--bs-header-height", `${topbarHeight}px`)
    }
    if (document.querySelector(".topbar") != null) {
      let getTopbarHeight = document.querySelector(".topbar").clientHeight;
      document.documentElement.style.setProperty("--bs-topbar-height", `${getTopbarHeight}px`)
    }
  }

  /**
   * Close Search Modal on Window Scroll
   *
   */
  closeSearchModal() {
    let searchModal = document.querySelector('search-modal') || null;
    if(searchModal == null) return;
    
    if(searchModal.classList.contains('open__modal') && typeof searchModal.close == 'function') searchModal.close(false);
  }

  /**
   * Close Menu Dropdowns
   *
   */
  closeMenuDropdowns() {
    let openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
    });
  }
}
customElements.define('sticky-header', StickyHeader);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[name="country_code"]')
    this.handleChange();
  }

  handleChange() {
    this.inputs?.forEach(input => {
      input.addEventListener('change', (e) => {
        e.preventDefault();
        e.currentTarget.closest('form').submit();
      })
    })
  }

}
customElements.define('localization-form', LocalizationForm)
